import * as actions from '../actionTypes';
import { GET_GRADES, ADD_GRADE, UPDATE_GRADE, DELETE_GRADE } from '../api';
import client from '../apolloClient';

export const deleteGrade = (grade_id) => async (dispatch) => {
    try {
        await client.mutate({
            mutation: DELETE_GRADE,
            variables: { input: grade_id },
        });
        const action = { type: actions.DELETE_GRADE, payload: grade_id };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}

export const setGrades = (grades) => async (dispatch) => {
    try {
        const action = { type: actions.SET_GRADES, payload: grades };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}

export const addGrade = (grade) => async (dispatch) => {
    try {
        const { data } = await client.mutate({
            mutation: ADD_GRADE,
            variables: { input: grade },
        });
        const savedGrade = data.createGrade;
        const action = { type: actions.ADD_GRADE, payload: savedGrade };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}


export const updateGrade = (grade) => async (dispatch) => {
    try {  
        const { data } = await client.mutate({
            mutation: UPDATE_GRADE,
            variables: { input: grade },
        });
        const savedGrade = data.updateGrade;
        const action = { type: actions.UPDATE_GRADE, payload: savedGrade };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}
